import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconPaymentAdd.tsx
const IconPaymentAdd = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "M17.2 15.906a1.57 1.57 0 0 1 1.575-1.563h11.189l-.01-8.436c0-.868-.7-1.574-1.564-1.574l-25.25.01c-.868 0-1.573.7-1.573 1.564l.01 15.52c0 .868.7 1.573 1.563 1.573l14.06-.001zM6.025 13.362V7.667h4.524q1.395 0 2.36.504.968.498 1.466 1.353.504.85.504 1.91 0 1.1-.51 1.94-.51.831-1.477 1.307-.966.468-2.343.468H8.192v.89h2.631v1.787H8.192v1.84H6.024v-1.84H4.26V16.04h1.764v-.89H4.26v-1.788z",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ jsx("path", { d: "M10.548 9.471q.732 0 1.206.264.48.258.715.709.24.446.235 1.008.005.574-.235 1.002a1.6 1.6 0 0 1-.726.667q-.487.24-1.242.24H8.19v-3.89zM19.766 23.667V21h10.667v2.667z" }),
			/* @__PURE__ */ jsx("path", { d: "M23.766 27.667V17h2.667v10.667z" })
		]
	})]
});
var IconPaymentAdd_default = forwardRef(IconPaymentAdd);
//#endregion
export { IconPaymentAdd_default as default };
